<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('borrowingSparePart.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('borrowingSparePart.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <ts-button outline @click.prevent="goToGenerateInv">
              {{ $t('borrowingSparePart.generateInvoice') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              style="width: 200px" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-checkbox v-model="isReturn" @change="fetchData()">Is Return</ts-checkbox>
            <label class="form-label col-label mt-3">{{
              $t('borrowingSparePart.warehouse')
            }}</label>
            <a-select v-model="location_id" style="width: 257px" :show-search="true" option-filter-prop="children"
              mode="multiple" :placeholder="$t('all')" :filter-option="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                ">
              <a-select-option v-for="(location, index) in locations" :key="index" :value="location.location_id">
                {{ location.location_name_en }}
              </a-select-option></a-select>
            <label class="form-label col-label mt-3">{{
              $t('borrowingSparePart.serviceType')
            }}</label>
            <a-select v-model="service_type_id" style="width: 200px" :show-search="true" option-filter-prop="children"
              mode="multiple" :max-tag-count="1" :placeholder="$t('all')" :filter-option="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                ">
              <a-select-option v-for="(serviceType, index) in serviceTypes" :key="index"
                :value="serviceType.service_type_id">
                {{ serviceType.service_type }}
              </a-select-option></a-select>
            <ts-input v-tooltip="$t('borrowingSparePart.search')" v-model="search"
              :placeholder="$t('borrowingSparePart.search')" style="width: 250px" class="inline-block" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.service_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.sfo_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.borrowing_ref }}</td>

            <!-- <td class="ts-whitespace-no-wrap">{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.reference_claim }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.discount_reference }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.reference_prq }}</td> -->
            <td class="ts-whitespace-no-wrap">{{ record.service_type }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.customer_name }}</td>
            <!-- <td class="ts-whitespace-no-wrap">
              {{ record.customer_name_invioce }}
            </td> -->

            <!-- <td class="ts-whitespace-no-wrap">{{ record.engine_number }}</td> -->
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.plate_number }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right"> $ 
              {{
                $formatNumber(
                  sumDiscountAmount(record.details)
                )
              }}
              
              <!-- {{
                $formatNumber(
                  sumDiscountAmount(record.details) * record.fx_rate_khr
                )
              }}
              ៛  take this on msk -->
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              $ 
              {{
                $formatNumber(
                  sumTotalAmount(record.details)
                )
              }}
              
              <!-- {{
                $formatNumber(
                  sumTotalAmount(record.details) * record.fx_rate_khr
                )
              }}
              ៛ take this on msk -->
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.requested_by_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.verified_by_name }}</td>
            <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('deliveryOrder.reprint')" class="text-primary text-red"
                @click.prevent="previewPdf(record)">
                <i class="fas fa-file-pdf"></i>
              </a>
              <a href="#" v-tooltip="$t('view')" class="text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <!-- v-if="!record.is_paid" -->
              <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="deleteRecord(record)">
                <a href="#" :disabled="record._deleting" v-tooltip="$t('delete')">
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
              <!-- <a
                href="#"
                v-tooltip="$t('claim')"
                class="text-primary"
                @click.prevent="showFormRef(record)"
              >
                <i class="fas fa-hand-holding-usd"></i>
              </a> -->
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
      <a-modal :title="$t('borrowingSparePart.updateReference')" width="300px" v-model="show_form_ref" :footer="null">
        <ts-loading-banner :loading="saving_update">
          <div class="ts-space-y-2">
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePart.referenceClaim') }}</label>
                <input type="text" class="form-control" v-model="model.reference_claim" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePart.referenceDiscount') }}</label>
                <input type="text" class="form-control" v-model="model.discount_reference" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePart.referencePRQ') }}</label>
                <input type="text" class="form-control" v-model="model.reference_prq" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 ts-flex ts-space-x-2 ts-justify-end">
                <ts-button @click.prevent="() => (show_form_ref = false)">{{
                  $t('cancel')
                }}</ts-button>
                <ts-button @click.prevent="updateReference" color="primary">{{
                  $t('save')
                }}</ts-button>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { debounce, includes, sumBy } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import PdfPreview from './components/pdf-preview.vue'

export default {
  name: 'borrowingSparePart',
  data() {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      show_form_ref: false,
      saving_update: false,
      locations: [],
      serviceTypes: [],
      src: '',
      printOpt: {
        paperSize: 'a5'
      },
      model: {
        sfo_id: null,
        reference_claim: '',
        discount_reference: '',
        reference_prq: ''
      }
    }
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['resources', 'pagination']),
    isSale() {
      return includes([3, 4], this.$store.state.authUser.user.mobile_role_id)
    },
    search: {
      get() {
        return this.$store.state.wholesale.borrowingSparePart.search
      },
      set(newValue) {
        this.$store.commit('wholesale/borrowingSparePart/SET_SEARCH', newValue)
        this.$store.commit('wholesale/borrowingSparePart/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.borrowingSparePart.dateRange
      },
      set(newValue) {
        this.$store.commit(
          'wholesale/borrowingSparePart/SET_DATE_RANGE',
          newValue
        )
      }
    },
    isReturn: {
      get() {
        return this.$store.state.wholesale.borrowingSparePart.isReturn
      },
      set(newValue) {
        this.$store.commit('wholesale/borrowingSparePart/SET_STATUS', newValue)
      }
    },
    location_id: {
      get() {
        return this.$store.state.wholesale.borrowingSparePart.location_id
      },
      set(newValue) {
        this.$store.commit(
          'wholesale/borrowingSparePart/SET_LOCATION_ID',
          newValue
        )
      }
    },
    service_type_id: {
      get() {
        return this.$store.state.wholesale.borrowingSparePart.service_type_id
      },
      set(newValue) {
        this.$store.commit(
          'wholesale/borrowingSparePart/SET_SERVICE_TYPE_ID',
          newValue
        )
      }
    },
    columns() {
      return [
        { name: this.$t('borrowingSparePart.branchName') },
        { name: this.$t('borrowingSparePart.serviceDate') },
        { name: this.$t('borrowingSparePart.borrowingNumber') },
        { name: this.$t('borrowingSparePart.borrowingRef') },
        // { name: this.$t('borrowingSparePart.invoiceRef') },
        // { name: this.$t('borrowingSparePart.referenceClaim') },
        // { name: this.$t('borrowingSparePart.referenceDiscount') },
        // { name: this.$t('borrowingSparePart.referencePRQ') },
        { name: this.$t('borrowingSparePart.serviceType') },
        { name: this.$t('borrowingSparePart.customer') },
        // { name: this.$t('borrowingSparePart.customerInvoice') },
        // { name: this.$t('borrowingSparePart.engineNumber') }, // keeping in msk
        {
          name: this.$t('borrowingSparePart.plateNumber')
        },
        {
          name: this.$t('borrowingSparePart.discountAmount'),
          style: 'text-align:right'
        },
        {
          name: this.$t('borrowingSparePart.amount'),
          style: 'text-align:right'
        },
        { name: this.$t('borrowingSparePart.requestBy') },
        { name: this.$t('borrowingSparePart.verifiedBy') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  methods: {
    ...mapActions('report/resource', ['getLocation']),

    getServiceTypes() {
      this.loading = true
      this.$store
        .dispatch('wholesale/borrowingSparePart/getFormViewData', {
          params: 'serviceType',
          index: 'serviceType'
        })
        .then(response => {
          this.serviceTypes = response.data['serviceType']
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    sumTotalAmount(details = []) {
      return sumBy(details, o => {
        let amount = o.sale_price * (o.quantity_order - o.quantity_return)
        return amount - (amount * o.discount_rate) / 100
      })
    },
    sumDiscountAmount(details = []) {
      return sumBy(details, o => {
        let amount = o.sale_price * (o.quantity_order - o.quantity_return)
        return (amount * o.discount_rate) / 100
      })
    },
    addNew() {
      this.$router.push({ name: 'borrowing-spare-part-create' })
    },

    goToGenerateInv() {
      this.$router.push({ name: 'borrowing-spare-part-generate' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/borrowingSparePart/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('wholesale/borrowingSparePart/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'borrowing-spare-part-edit',
        params: { id: record.sfo_id }
      })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('wholesale/borrowingSparePart/destroy', record.sfo_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    getLocations() {
      this.loading = true
      this.getLocation()
        .then(response => {
          this.locations = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/borrowingSparePart/SET_BRANCH_ID', value)
      this.fetchData()
    },
    previewPdf(record) {
      this.$confirm({
        title: this.$t('which_paper_size_you_wish'),
        content: h =>
          h(PdfPreview, {
            props: {
              value: this.printOpt
            }
          }
          ),
        okText: this.$t('preview'),
        cancelText: this.$t('cancel'),
        centered: true,
        onOk: () => {
          this.show_pdf = true
          this.waiting = true
          return this.$store
            .dispatch('wholesale/borrowingSparePart/previewPdf',
              {
                sfo_id: record.sfo_id,
                paper_size: this.printOpt.paperSize
              })
            .then(response => {
              this.$toasted.success(response.message)
              this.src = response.url
              return Promise.resolve(response)
            })
            .catch(error => {
              this.waiting = false
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
            .finally(() => {
              this.waiting = false
            })
        },
        onCancel() { }
      })
    },
    // previewPdf (record) {
    //   this.show_pdf = true
    //   this.waiting = true
    //   this.src = ''
    //   this.$store
    //     .dispatch('wholesale/borrowingSparePart/previewPdf', record.sfo_id)
    //     .then(response => {
    //       this.src = response.url
    //     })
    //     .catch(error => {
    //       this.$toasted.error(error.message)
    //     })
    //     .finally(() => {
    //       this.waiting = false
    //     })
    // },
    showFormRef(record) {
      this.show_form_ref = true
      this.model.sfo_id = record.sfo_id
      this.model.reference_claim = record.reference_claim
      this.model.discount_reference = record.discount_reference
      this.model.reference_prq = record.reference_prq
    },
    updateReference() {
      this.saving_update = true
      this.$store
        .dispatch('wholesale/borrowingSparePart/updateRef', {
          id: this.model.sfo_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.show_form_ref = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.saving_update = false
        })
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    location_id: debounce(function () {
      this.fetchData(this.search)
    }, 500),
    service_type_id: debounce(function () {
      this.fetchData(this.search)
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.getLocations()
      vm.getServiceTypes()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/borrowingSparePart/RESET_STATE')
    next()
  }
}
</script>
